module.exports = __webpack_public_path__ + "img/DefIMG_Prod_LT.336a16eb.svg";